import { makeStyles } from '@material-ui/core'

const width = 160

const getColor = (theme, color) => theme.palette?.[color]?.main

export const useStyles = makeStyles(theme => ({
   container: {
      width: width,
      position: 'relative'
   },
   statusSelector: {
      cursor: props => (props?.disabled ? 'normal' : 'pointer'),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minWidth: width,
      gap: 5,
      color: props => getColor(theme, props?.color),
      backgroundColor: props => `color-mix(in srgb, ${getColor(theme, props?.color)} 5%, transparent)`,
      padding: '4px 12px',
      borderRadius: 14,
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: 12
   },
   led: {
      width: 9,
      height: 9,
      borderRadius: '50%',
      marginLeft: 5,
      backgroundColor: props => getColor(theme, props?.color)
   },
   menulist: {
      width: props => props.menuWidth ?? 0,
      padding: 0
   },
   statusLabel: {
      marginLeft: 8
   }
}))
